import { normalizeAssistantStatus } from "@/store/assistant/assistant-status";
import { AssistantProjectStatus } from "@/store/assistant/types";

const CLOSED_ASSISTANT_PROJECT_STATUS_VALUES = new Set<string>([
  AssistantProjectStatus.Resolved,
  AssistantProjectStatus.Archived,
]);

export const isClosedAssistantProjectStatus = ({ status }: { status: string }) =>
  CLOSED_ASSISTANT_PROJECT_STATUS_VALUES.has(normalizeAssistantStatus({ status }));
